const LOCALE = { de: "de-DE", en: "en-GB", es: "es-ES", nl: "nl-NL", pl: "pl-PL", fr: "fr-FR", it: "it-IT" };
export const localeOf = (lang) => LOCALE[lang] || "de-DE";

const MONTHS_DE = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
const MONTHS_DE_SHORT = ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"];
export const monthName = (m, lang = "de", short = false) => (lang === "de" || !lang)
  ? (short ? MONTHS_DE_SHORT[m] : MONTHS_DE[m])
  : new Date(Date.UTC(2000, m, 15)).toLocaleDateString(localeOf(lang), { month: short ? "short" : "long", timeZone: "UTC" });

// Datum als TT.MM.JJJJ (DE) bzw. Landesformat; akzeptiert ISO-Strings und Date-Objekte
export const fmtDate = (d, lang = "de") => {
  if (!d) return "";
  const x = typeof d === "string" && /^\d{4}-\d{2}-\d{2}$/.test(d) ? new Date(d + "T00:00:00") : new Date(d);
  return isNaN(x) ? String(d) : x.toLocaleDateString(LOCALE[lang] || "de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export const fmtRange = (a, b, lang = "de") => `${fmtDate(a, lang)} – ${fmtDate(b, lang)}`;

// Geldbetrag: „€777,20“ bzw. „€955“ (ohne Nachkommastellen, wenn glatt); Trennzeichen je Sprache
export const fmtMoney = (v, lang = "de") => {
  const n = Number(v) || 0;
  const cents = Math.abs(n - Math.round(n)) > 0.004;
  return `€${n.toLocaleString(localeOf(lang), { minimumFractionDigits: cents ? 2 : 0, maximumFractionDigits: 2 })}`;
};

const STATUS = { confirmed: "Bestätigt", pending: "Ausstehend", cancelled: "Storniert", completed: "Abgeschlossen", "kA v. Vermieter": "KA Vermieter", "abgesagt von Kunden": "Kunde abgesagt",
  "Buchung abgelaufen": "Abgelaufen", bezahlt: "Bezahlt", belegt: "Belegt", gebucht: "Gebucht", storniert: "Storniert", umbuchung: "Umbuchung" };
export const bookingStatusLabel = (s) => STATUS[s] || s;
